// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text_editor__required .ql-container.ql-snow{background:#fff!important;border:1px solid #f83245!important;border-radius:0 0 4.64px 4.64px!important}.text_editor__required .ql-toolbar.ql-snow{background:#fff!important;border:1px solid #f83245!important;border-radius:4.64px 4.64px 0 0!important;border-bottom:none!important}.text_feedback{width:100%;margin-top:.25rem;font-size:80%;color:#f83245}", ""]);
// Exports
module.exports = exports;
